import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    backgroundColor: "#fff",
  },
  stepperContainer: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 16px",
    backgroundColor: "#fff",
    [theme.breakpoints.up("md")]: {
      width: "85%",
      padding: 0,
    },
  },
  stepper: {
    width: "100%",
    padding: "50px 24px 24px",
    backgroundColor: "#fff",
    "& .MuiStepConnector-line": {
      borderColor: "#e0e0e0",
    },
    "& .MuiStepConnector-root": {
      top: "15px",
    },
  },
  stepCompleted: {
    color: "#4CAF50",
  },
  backButton: {
    display: "flex",
    alignItems: "center",
    color: "#ec6535",
    marginBottom: "1rem",
    marginTop: "1rem",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  button: {
    minWidth: 180,
    borderRadius: 30,
    textTransform: "none",
    transition: 'background-color 0.3s ease, color 0.3s ease',
    '&.MuiButton-contained:hover': {
      backgroundColor: '#000000 !important',
      color: '#fff !important',
    },
    '&.MuiButton-outlined:hover': {
      backgroundColor: '#000000',
      color: '#fff',
      borderColor: '#000',
    },
  },
  stepperHeader: {
    padding: "32px 0",
    textAlign: "center",
    backgroundColor: "#F5F9FF",
    position: "relative",
  },
  heading: {
    fontWeight: 500,
    fontSize: 30,
    lineHeight: "100%",
    marginBottom: 20,
  },
  subheading: {
    fontWeight: 400,
    fontSize: 16,
    lineHeight: "100%",
  },
  stepLabel: {
    flexDirection: "column",
    fontSize: 15,
    position: "relative",
    "& .MuiStepLabel-iconContainer": {
      padding: 0,
    },
    "& .MuiStepLabel-labelContainer": {
      width: "auto",
      minWidth: 140,
      position: "absolute",
      left: "50%",
      top: 30,
      transform: " translateX(-50%)",
      textAlign: "center",
    },
  },
  formTitle: {
    fontSize: "24px",
    lineHeight: "39px",
    fontWeight: 600,
    margin: "24px 0 24px 0",
    position: "relative",
    paddingBottom: "0.3rem",
    "&::after": {
      content: '""',
      display: "block",
      border: "2px solid #707070",
      width: "1.6rem",
      height: "0",
      backgroundColor: "#707070",
      marginTop: "0.3rem",
    },
  },
  stepContent: {
    padding: "24px",
    paddingTop: "16px",
    backgroundColor: "#fff",
    minHeight: "500px",
    width: "100%",
  },
  contentWrapper: {
    width: "100%",
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "0 16px 24px",
    backgroundColor: "#fff",
    [theme.breakpoints.up("md")]: {
      width: "85%",
      padding: "0 0 24px",
    },
  },
  twoColFormsGrid: {
    "& .two-col-forms-grid": {
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      gap: "24px",
      margin: 0,
      width: "100%",
      rowGap: "32px",
      "& > div": {
        flex: "1 1 100%",
        maxWidth: "100%",
        padding: 0,
        [theme.breakpoints.up("md")]: {
          flex: "0 1 calc(50% - 12px)",
          maxWidth: "calc(50% - 12px)",
        },
        [theme.breakpoints.up("lg")]: {
          flex: "0 1 480px",
          maxWidth: "480px",
        },
      },
    },
  },
}));

